import { Links } from 'application/constants/links';
import styles from './TemplatePage.module.scss';
import TemplateEditor from 'components/documents/editors/TemplateEditor';

export const TemplatePage: React.FC = () => {
  const params = Links.Authorized.OpenTemplate.useParams();

  return (
    <div className={styles.container} data-test-id="template-page">
      <TemplateEditor templateId={params.templateId} />
    </div>
  );
};
